import { combineReducers } from 'redux-immutable'
import { error } from './error/reducer'
import { reducer as simulationReducer } from '../scenes/Simulation/services/reducer'
import messageReducer from './messages/messagesReducer'

const sessionReducer = combineReducers({
  simulation: simulationReducer,
  messages: messageReducer,
  error
})
export default sessionReducer
export { sessionReducer }
